import request from '@/plugin/axios'

export function page(query) {
return request({
url: '/api/admin/inrecord/pageList',
method: 'get',
params: query
})
}

export function addObj(obj) {
return request({
url: '/api/admin/inrecord/save',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/admin/inrecord/' + id,
method: 'get'
})
}

export function delObj(id) {
return request({
url: '/api/admin/inrecord/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/inrecord/' + id,
method: 'put',
data: obj
})
}
